import ContactLink from "@/components/ContactLink";
import { Head, Link, usePage } from "@inertiajs/react";
import { ArrowRight, School, GraduationCap, Heart, Gift, Search } from "lucide-react";
import HelpLayout from "@/components/help/HelpLayout";
import { ROLES, ROLE_ORDER } from "@/help/roles";

const ICONS = {
  school_admins: School,
  teachers: GraduationCap,
  parents: Heart,
  donors: Gift,
};

const ACCENTS = {
  school_admins: "border-primary/30 bg-primary/5 hover:border-primary/60",
  teachers: "border-info/30 bg-info/5 hover:border-info/60",
  parents: "border-accent/30 bg-accent/5 hover:border-accent/60",
  donors: "border-warning/30 bg-warning/10 hover:border-warning/60",
};

const ICON_COLORS = {
  school_admins: "bg-primary/10 text-primary",
  teachers: "bg-info/10 text-info",
  parents: "bg-accent/10 text-accent",
  donors: "bg-warning/15 text-warning-foreground",
};

export default function Index() {
  return (
    <HelpLayout
      roleSlug={null}
      eyebrow="Help centre"
      title="What do you need help with?"
    >
      <Head title="Help centre · PagePledge" />

      <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mb-10">
        Pick whatever fits what you're doing right now. Most articles take a couple of minutes to read, with screenshots so you can see what you'll actually click.
      </p>

      <div className="grid gap-4 md:grid-cols-2">
        {ROLE_ORDER.map((slug) => {
          const role = ROLES[slug];
          const Icon = ICONS[slug];
          return (
            <Link
              key={slug}
              href={role.helpPath}
              className={`group block rounded-2xl border-2 p-6 transition-colors ${ACCENTS[slug]}`}
            >
              <div className="flex items-start gap-4">
                <span className={`inline-flex items-center justify-center h-11 w-11 rounded-xl ${ICON_COLORS[slug]} shrink-0`}>
                  <Icon className="h-6 w-6" />
                </span>
                <div className="flex-1 min-w-0">
                  <h2 className="font-display text-xl font-semibold text-foreground">
                    {role.label}
                  </h2>
                  <p className="text-sm text-muted-foreground leading-relaxed mt-1">
                    {role.description}
                  </p>
                  <p className="text-sm font-medium text-primary mt-3 inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                    Open guide <ArrowRight className="h-4 w-4" />
                  </p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="mt-14 rounded-xl border border-border bg-card/40 px-6 py-5">
        <div className="flex items-start gap-3">
          <Search className="h-5 w-5 text-muted-foreground mt-0.5 shrink-0" />
          <div>
            <h3 className="font-display text-base font-semibold text-foreground">
              Can't find an answer?
            </h3>
            <p className="text-sm text-muted-foreground leading-relaxed mt-1">
              Email{" "}
              <ContactLink className="text-primary hover:underline">
                hello@pagepledge.com
              </ContactLink>{" "}
              and we'll get back to you. We’re a small team and answer messages ourselves, usually the same day.
            </p>
          </div>
        </div>
      </div>
    </HelpLayout>
  );
}
